import { basicEnum } from "./base";

export const DiscountUnitEnum = basicEnum([
    {
        label: "Rupiah (Rp.)",
        value: "currency",
    },
    {
        label: "Persentase (%)",
        value: "percentage",
    },
]);

export namespace DiscountUnitEnum {
    export type Labels = (typeof DiscountUnitEnum)["labels"][number];
    export type Values = (typeof DiscountUnitEnum)["values"][number];
}
